import Vue from 'vue';
import VueRouter from 'vue-router';

import StorageService from '@/services/StorageService';
import { STORAGE_KEYS } from '@/constants/storage';
import Home from '../views/Home.vue';
import Main from '../views/Main.vue';
import Maintenance from '../views/Maintenance.vue';
import Settings from '../views/Settings.vue';
import IconSetting from '../views/settings/icon/IconSetting.vue';
import MainIconSetting from '../views/settings/icon/MainIconSetting.vue';
import NoticeSetting from '../views/settings/notice/NoticeSetting.vue';
import MainNoticeSetting from '../views/settings/notice/MainNoticeSetting.vue';
import PushSetting from '../views/settings/notice/PushSetting.vue';
import NoticeMailSetting from '../views/settings/notice/NoticeMailSetting.vue';
import NoticeTargetSetting from '../views/settings/notice/NoticeTargetSetting.vue';
import UsersSetting from '../views/settings/users/UsersSetting.vue';
import EditUsersSetting from '../views/settings/users/EditUsersSetting.vue';
import UserCamSelect from '../views/settings/users/UserCamSelect.vue';
import MainUsersSetting from '../views/settings/users/MainUsersSetting.vue';
import MfaSetting from '../views/account/mfa/MfaSetting.vue';
import SelectMfaSetting from '../views/account/mfa/SelectMfaSetting.vue';
import SmsMfaSetting from '../views/account/mfa/SmsMfaSetting.vue';
import TotpMfaSetting from '../views/account/mfa/TotpMfaSetting.vue';
import NoMfaSetting from '../views/account/mfa/NoMfaSetting.vue';
import CamsSetting from '../views/settings/cams/CamsSetting.vue';
import MainCamsSetting from '../views/settings/cams/MainCamsSetting.vue';
import MainFirmwareSetting from '../views/settings/firmware/MainFirmwareSetting.vue';
import FirmwareCamsTable from '../views/settings/firmware/FirmwareCamsTable.vue';
import FirmwareDetails from '../views/settings/firmware/FirmwareDetails.vue';
import FirmwareModeSetting from '../views/settings/firmware/FirmwareModeSetting.vue';
import ListCamsSetting from '../views/settings/cams/ListCamsSetting.vue';
import DetailCamsSetting from '../views/settings/cams/DetailCamsSetting.vue';
import EditCamsGroup from '../views/settings/cams/EditCamsGroup.vue';
import EditCamsSetting from '../views/settings/cams/EditCamsSetting.vue';
import RegisteredCams from '../views/settings/RegisteredCams.vue';
import RecordSetting from '../views/settings/RecordSetting.vue';
import SettingHistory from '../views/settings/history/SettingHistory.vue';
import OperationHistory from '../views/settings/history/OperationHistory.vue';
import EventHistory from '../views/settings/history/EventHistory.vue';
import SystemHistory from '../views/settings/history/SystemHistory.vue';
import Account from '../views/Account.vue';
import Forgot from '../views/forgot/Forgot.vue';
import AccountPassword from '../views/account/AccountPassword.vue';
import SwitchOrg from '../views/account/SwitchOrg.vue';
// import AccountChangeEmail from '../views/account/AccountChangeEmail.vue';
import AccountChangeName from '../views/account/AccountChangeName.vue';
import Help from '../views/Help.vue';
import HelpContract from '../views/help/contract/HelpContract.vue';
import HelpContractList from '../views/help/contract/HelpContractList.vue';
import HelpContractDetail from '../views/help/contract/HelpContractDetail.vue';
import HelpContractConfirm from '../views/help/contract/HelpContractConfirm.vue';
import HelpContractEmail from '../views/help/contract/HelpContractEmail.vue';
import HelpCamSelect from '../views/help/HelpCamSelect.vue';
import Login from '../views/login/Login.vue';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/index.html',
    redirect: { name: 'home' },
  },
  {
    path: '/',
    redirect: { name: 'home' },
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    component: Maintenance,
    meta: { requiredLogin: false },
  },
  {
    path: '/login/:id?',
    name: 'login',
    component: Login,
    meta: { requiredLogin: false },
  },
  {
    path: '/mfa/reset/:token',
    name: 'login-mfa-reset',
    component: Login,
    meta: { requiredLogin: false },
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: Forgot,
    meta: { requiredLogin: false },
  },
  {
    path: '/main',
    component: Main,
    children: [
      {
        path: '',
        redirect: { name: 'home' },
      },
      {
        path: 'dashboard/:id?',
        name: 'home',
        component: Home,
      },
      {
        path: 'multi-camera',
        name: 'multi-camera',
        component: Home,
      },
      {
        path: 'clip',
        name: 'clip',
        component: Home,
      },
      {
        path: 'clip/:id/:tag?',
        name: 'clip-detail',
        component: Home,
      },
      {
        path: 'events',
        name: 'events',
        component: Home,
      },
      {
        path: 'video',
        name: 'video',
        component: Home,
      },
      {
        path: 'map',
        name: 'map',
        component: Home,
      },
      {
        path: 'history',
        name: 'history',
        component: Home,
      },
      {
        path: 'settings',
        redirect: 'settings/firmware',
      },
      {
        path: 'settings',
        name: 'settings',
        component: Settings,
        redirect: { name: 'settings-account-org' },
        children: [
          {
            path: 'info/:child?',
            name: 'settings-info',
            component: RegisteredCams,
          },
          {
            path: 'org',
            name: 'settings-account-org',
            component: SwitchOrg,
          },
          {
            path: 'firmware',
            name: 'settings-firmware',
            component: MainFirmwareSetting,
            redirect: 'firmware',
            children: [
              {
                path: '',
                name: 'settings-firmware-table',
                component: FirmwareCamsTable,
              },
              {
                path: 'details/:id',
                name: 'settings-firmware-details',
                component: FirmwareDetails,
              },
              {
                path: 'details/:id/edit',
                name: 'settings-firmware-details-edit',
                component: FirmwareDetails,
              },
              {
                path: 'details/:id/motion',
                name: 'settings-firmware-motion',
                component: FirmwareDetails,
              },
              {
                path: 'details/:id/mode',
                name: 'settings-firmware-mode',
                component: FirmwareModeSetting,
              },
            ],
          },
          {
            path: 'users',
            name: 'settings-users',
            component: UsersSetting,
            redirect: 'users',
            children: [
              {
                path: '',
                name: 'settings-users-main',
                component: MainUsersSetting,
              },
              {
                path: 'new',
                name: 'settings-users-new',
                component: EditUsersSetting,
              },
              {
                path: 'select-cam',
                name: 'settings-users-select-cam',
                component: UserCamSelect,
              },
              {
                path: 'edit/:userId',
                name: 'settings-users-edit',
                component: EditUsersSetting,
              },
              {
                path: 'edit/:userId/select-cam',
                name: 'settings-users-edit-select-cam',
                component: UserCamSelect,
              },
            ],
          },
          {
            path: 'notice',
            name: 'settings-notice',
            component: NoticeSetting,
            redirect: 'notice',
            children: [
              {
                path: '',
                name: 'settings-notice-main',
                component: MainNoticeSetting,
              },
              {
                path: 'push',
                name: 'settings-notice-push',
                component: PushSetting,
              },
              {
                path: 'mail',
                name: 'settings-notice-mail',
                component: NoticeMailSetting,
              },
              {
                path: 'target',
                name: 'settings-notice-target',
                component: NoticeTargetSetting,
              },
            ],
          },
          {
            path: 'icon',
            name: 'settings-icon',
            component: IconSetting,
            redirect: 'icon',
            children: [
              {
                path: '',
                name: 'settings-icon-main',
                component: MainIconSetting,
              },
            ],
          },
          {
            path: 'cams',
            name: 'settings-cams',
            component: CamsSetting,
            redirect: { name: 'settings-cams-list', params: { group: 1 } },
            children: [
              {
                path: '',
                name: 'settings-cams-main',
                component: MainCamsSetting,
              },
              {
                path: 'new',
                name: 'settings-cams-new',
                component: EditCamsSetting,
              },
              {
                path: 'list/:group',
                name: 'settings-cams-list',
                component: ListCamsSetting,
              },
              {
                path: 'list/:group/order',
                name: 'settings-cams-order',
                component: ListCamsSetting,
              },
              {
                path: 'list/:group/detail/:id',
                name: 'settings-cams-list-detail',
                component: DetailCamsSetting,
              },
              {
                path: 'list/:group/detail/:id/order',
                name: 'settings-cams-list-detail-edit-sorting',
                component: DetailCamsSetting,
              },
              {
                path: 'list/:group/detail/:id/edit',
                name: 'settings-cams-list-detail-edit',
                component: EditCamsGroup,
              },
              {
                path: 'list/:group/detail/:id/edit',
                name: 'settings-cams-detail-edit',
                component: EditCamsSetting,
              },
            ],
          },
          {
            path: 'record/:child?',
            name: 'settings-record',
            component: RecordSetting,
          },
          {
            path: 'history',
            name: 'settings-history',
            redirect: 'history/operation',
            component: SettingHistory,
            children: [
              {
                path: 'operation',
                name: 'settings-history-operation',
                component: OperationHistory,
              },
              {
                path: 'event',
                name: 'settings-history-event',
                component: EventHistory,
              },
              {
                path: 'system',
                name: 'settings-history-system',
                component: SystemHistory,
              },
            ],
          },
        ],
      },
      {
        path: 'account',
        redirect: 'account/name',
      },
      {
        path: 'account',
        name: 'account',
        component: Account,
        redirect: 'account/name',
        children: [
          // {
          //   path: 'email',
          //   name: 'account-email',
          //   component: AccountChangeEmail,
          // },
          {
            path: 'name',
            name: 'account-name',
            component: AccountChangeName,
          },
          {
            path: 'password',
            name: 'account-password',
            component: AccountPassword,
          },
          {
            path: 'mfa',
            name: 'account-mfa',
            component: MfaSetting,
            redirect: { name: 'account-mfa-select' },
            children: [
              {
                path: '',
                name: 'account-mfa-select',
                component: SelectMfaSetting,
              },
              {
                path: 'sms',
                name: 'account-mfa-sms',
                component: SmsMfaSetting,
              },
              {
                path: 'totp',
                name: 'account-mfa-totp',
                component: TotpMfaSetting,
              },
              {
                path: 'nomfa',
                name: 'account-mfa-nomfa',
                component: NoMfaSetting,
              },
            ],
          },
        ],
      },
      {
        path: 'help',
        name: 'help',
        component: Help,
        children: [
          {
            path: 'cat/:id',
            name: 'help-cat',
            component: HelpContract,
          },
          {
            path: 'cat/:id/list/:topic',
            name: 'help-cat-list',
            component: HelpContractList,
          },
          {
            path: 'cat/:id/list/:topic/detail/:qid',
            name: 'help-cat-detail',
            component: HelpContractDetail,
          },
          {
            path: 'cat/:id/list/:topic/detail/:qid/confirm',
            name: 'help-confirm',
            component: HelpContractConfirm,
          },
          {
            path: 'cat/:id/list/:topic/detail/:qid/email',
            name: 'help-email',
            component: HelpContractEmail,
          },
          {
            path: 'cat/:id/list/:topic/detail/:qid/cam',
            name: 'help-cam-select',
            component: HelpCamSelect,
          },
        ],
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (from.name && to.name === 'multi-camera') {
    try {
      store.commit('common/setIsLoading', true);
      await store.dispatch('common/fetchReorderCameraGroup', {
        noSelectedGroupChange: false,
      });
    } catch (error) {
      console.error('Failed to fetch camera group for multi-camera:', error);
    } finally {
      store.commit('common/setIsLoading', false);
    }
  }
  if (from.name && to.name === 'home') {
    try {
      store.commit('common/setIsLoading', true);
      await store.dispatch('common/fetchReorderCameraGroup', {
        noSelectedGroupChange: false,
      });
    } catch (error) {
      console.error('Failed to fetch camera group for home:', error);
    } finally {
      store.commit('common/setIsLoading', false);
    }
  }
  const token = StorageService.getItem(STORAGE_KEYS.SCMCognitoToken);
  if (!token) {
    if (to.meta.requiredLogin !== false) {
      StorageService.performLogoutCleanup();
      return next({ name: 'login', query: { reload: 1 } });
    }
  } else {
    if (to.name === 'login') {
      return next({ name: 'home' });
    }
  }
  return next();
});

export default router;
